var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',[(!_vm.activeItem)?_c('loader'):_vm._e(),_vm._v(" "),(_vm.activeItem)?_c('div',[_vm._v("\n\t\t\t"+_vm._s(_vm.activeItem)+"\n\t\t")]):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v("Campaign")])])
}]

export { render, staticRenderFns }